<template>
<div class="chapter">
<div class="inner_page">
<p class="p10"><span class="t13">To Joseph</span></p>
<p class="p0"><span class="t13">No act of kindness is ever wasted.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006.vue?060bb12f